import i18n from "@/i18n"

export default {
  path: "/returns",
  component: () => import("./index.vue"),
  name: "returns",
  meta: {
    title: "returns.title"
  }
}
